module.exports = __webpack_public_path__ + "static/img/solutionDetailIcon11.6c59e2d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailIcon11.png
// module id = KMnh
// module chunks = 0